export const animateCoreElements = () => {
	const elements = document.querySelectorAll('.page-content > :not(section)');

	if (elements && elements.length > 0) {
		Array.prototype.forEach.call(elements, (element) => {
			element.classList.add('animate-in', 'animation-fade-in');
		});
	}
};
